import styled, { CSSProperties } from "styled-components";

interface StyledProps {
  customStyles?: CSSProperties;
  navigationDirection?: "left" | "right" | null;
  animate?: boolean;
}
export const ModalOverLay = styled.div<StyledProps>`
  position: fixed;
  width: 100%;
  height: 100%;
  inset: 0;
  z-index: 200;
  backdrop-filter: blur(6px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow-x: hidden;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  padding: 2% 3%;
  ${(props) =>
    props?.customStyles &&
    Object.entries(props.customStyles)
      .map(
        ([key, value]) =>
          `${key.replace(
            /[A-Z]/g,
            (match) => `-${match.toLowerCase()}`,
          )}: ${value};`,
      )
      .join("\n")}

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  ${(props) => (!props.animate ? "animation: fadeIn 0.3s ease-in-out;" : "")}

  @media (max-width: 1200px), (max-height: 592px) {
    justify-content: flex-start;
  }
`;

export const Wrapper = styled.div<StyledProps>`
  position: relative;
  background-color: white;
  border-radius: 17px;
  box-shadow: 0px 5px 16px 4px #8888886b;
  margin-top: 64px;
  margin-bottom: 64px;
  ${(props) =>
    props?.customStyles &&
    Object.entries(props.customStyles)
      .map(
        ([key, value]) =>
          `${key.replace(
            /[A-Z]/g,
            (match) => `-${match.toLowerCase()}`,
          )}: ${value};`,
      )
      .join("\n")}

  @keyframes slideInFromLeft {
    from {
      transform: translateX(-100vw);
      opacity: 1;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  @keyframes slideInFromRight {
    from {
      transform: translateX(100vw);
      opacity: 1;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  @keyframes scaleIn {
    from {
      transform: scale(0.9);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }

  ${(props) =>
    props.navigationDirection
      ? `animation: ${
          props.navigationDirection === "left"
            ? "slideInFromLeft"
            : "slideInFromRight"
        } 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);`
      : !props.animate
        ? "animation: scaleIn 0.3s ease-in-out;"
        : ""}
`;
